<template>
  <div
    class="fixed flex flex-col flex-reverse items-end bottom-0 right-0 space-y-4"
    style="z-index: 900"
  >
    <!-- z-index > var(--sgdf-z-index-toast) -->
    <div
      v-for="notification in notifications"
      :key="notification.notifyTime"
    >
      <sl-alert
        v-if="notification.contentType === 'basic'"
        class="m-4"
        :variant="notification.type"
        open
      >
        <sgdf-icon slot="icon" :name="notification.icon" />
        {{ notification.message }}
      </sl-alert>

      <sl-alert
        v-else-if="notification.contentType === 'error'"
        class="m-4"
        :variant="notification.type"
        open
      >
        <sgdf-icon slot="icon" :name="notification.icon" />
        <strong>Erreur</strong><br />
        {{ notification.message }}
      </sl-alert>

      <sl-alert v-else class="m-4" :variant="notification.type" open>
        <sgdf-icon slot="icon" :name="notification.icon" />
        <strong>{{ notification.title }}</strong
        ><br />
        {{ notification.detail }}
      </sl-alert>
    </div>
  </div>
</template>

<script setup lang="ts">
import "@shoelace-style/shoelace/dist/components/alert/alert.js";
import "@sgdf/ui-library/sgdf-icon.js";
import "@shoelace-style/shoelace/dist/components/icon-button/icon-button.js";

import { storeToRefs } from "pinia";
import { useNotifyStore } from "~/composables/notify-store";

const notifyStore = useNotifyStore();
const { notifications } = storeToRefs(notifyStore);
</script>
